import React, { memo } from 'react'
import { string } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const BusinessAccountType = memo(({ width = '89px', height = '75px' }) => {
	const {
		colors: { primary, secondary },
	} = useTheme()

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 89 75">
			<g fill="none" fillRule="evenodd">
				<path
					fill={secondary}
					fillRule="nonzero"
					d="M50.8 55.2l-6.4-1.8-.1 1.4c3.1 1 5.9 2.8 5.9 6v6.7c0 2.5-1.5 4.5-3.5 5.5h4.1c3.1 0 5.7-2.5 5.7-5.7V61c0-3.2-2.7-4.9-5.7-5.8zM29.7 16.2c-1.3 0-2.6.2-3.8.5 6.6 1.7 11.5 7.7 11.5 14.8v8.1c0 7.1-4.9 13.1-11.5 14.8 1.2.3 2.5.5 3.8.5C38.2 54.9 45 48 45 39.6v-8.1c0-8.4-6.8-15.3-15.3-15.3z"
				/>
				<path
					stroke={secondary}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="3"
					d="M29.7 16.2c-8.5 0-15.3 6.9-15.3 15.3v8.1c0 8.5 6.9 15.3 15.3 15.3C38.2 54.9 45 48 45 39.6v-8.1c0-8.4-6.8-15.3-15.3-15.3z"
				/>
				<path
					stroke={primary}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="3"
					d="M45.6 53.9l6.4 1.8c3 .9 5.7 2.6 5.7 5.7v6.3c0 3.2-2.6 5.7-5.7 5.7H7.2c-3.2 0-5.7-2.6-5.7-5.7v-6.2c0-3.2 2.7-4.8 5.7-5.7l6.7-1.8"
				/>
				<path
					stroke={primary}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="3"
					d="M29.7 16.2c-8.5 0-15.3 6.9-15.3 15.3v8.1c0 8.5 6.9 15.3 15.3 15.3C38.2 54.9 45 48 45 39.6v-8.1c0-8.4-6.8-15.3-15.3-15.3z"
				/>
				<path
					fill={secondary}
					fillRule="nonzero"
					d="M69.4 1.5c-1.2 0-2.3.1-3.4.3 7.7 1.6 13.6 8.4 13.6 16.6 0 5-2.2 9.5-5.6 12.6l-4.8 4.8v6.8L80.8 31c3.4-3.1 5.6-7.6 5.6-12.6-.1-9.3-7.7-16.9-17-16.9z"
				/>
				<g stroke={primary} strokeLinecap="round" strokeLinejoin="round" strokeWidth="3">
					<path d="M60.9 15.5h17.9M60.9 22.3h17.9M87 18.5c0-9.4-7.6-17-17-17s-17 7.6-17 17c0 9.3 7.5 16.9 16.8 17v7.2l11.6-11.6C84.9 28 87 23.5 87 18.5z" />
				</g>
			</g>
		</svg>
	)
})

BusinessAccountType.propTypes = {
	width: string,
	height: string,
}
